import request from '@/router/axios';

const baseUrl = "/ds_resource"

// 设备概况
export const unit_list = () => request({
    url: baseUrl+ '/unit/list',
    method: 'get'
});

